import { render } from "./DashboardNavbar.vue?vue&type=template&id=17087f33"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__